import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollRestoration
 * @description
 * Resets the scroll position to the top whenever the route changes.
 *
 * Under AppLayout the window never scrolls: the shell is pinned to 100vh and
 * `<main id="main-content">` owns the `overflow-y: auto`. Scrolling `window`
 * there does nothing, which is why navigating used to leave you wherever the
 * previous screen was scrolled.
 * @returns null
 */
function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    // AppLayout scrolls an inner element; FullscreenLayout scrolls the window.
    (document.getElementById('main-content') ?? window).scrollTo({ top: 0 });
  }, [pathname]);

  return null;
}

export default ScrollRestoration;
